import { normalize } from 'normalizr'

import { jsonGet } from '../api'

import { locationSchema, POIScheme } from './schemas'

const locationsSchema = {
    content: [locationSchema],
}

export const fetchLocations = (params, page = 0) =>
    jsonGet(`${SF_PROXY_URL}/locations`, {
        ...params,
        page,
    }).then(response => normalize(response, locationsSchema))

export const fetchLocationById = (id, language) =>
    jsonGet(`${SF_PROXY_URL}/locations/${id}`, { language }).then(response => normalize(response, locationSchema))

export const fetchLocationByGrsId = (grsId, language) =>
    jsonGet(`${SF_PROXY_URL}/locations/grs/${grsId}`, { language }).then(response =>
        normalize(response, locationSchema)
    )

export const fetchPlacesOfInterest = params =>
    jsonGet(`${SF_PROXY_URL}/pois`, {
        ...params,
    }).then(({ content }) => normalize(content, [POIScheme]))

export const fetchPlaceOfInterestById = placeOfInterestId =>
    jsonGet(`${SF_PROXY_URL}/pois/${placeOfInterestId}`).then(response => normalize(response, POIScheme))
